<template>
    <v-dialog v-model="visible" max-width="600" persistent>
        <v-card class="pa-0">
            <!-- Header -->
            <div class="dialog-header d-flex align-center justify-space-between px-6 py-4">
                <span class="dialog-title font-weight-bold white--text">{{ $t("esgPlatform.esgReport.addNew") }}</span>
                <v-btn icon @click="close" class="white--text">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>

      <!-- Block Type Selection -->
      <v-card-text class="py-4 px-0">
        <v-container fluid>
          <!-- Customizable Blocks -->
          <v-row dense>
            <div class="dialog-title font-weight-bold block-btn-label mb-3">{{ $t("esgPlatform.esgReport.customSections") }}</div>
            <v-col cols="12" v-for="item in customizableBlocks" :key="item.type">
              <v-btn
                :class="['block-btn', selectedType === item.type ? 'block-btn--active' : '']"
                block large depressed color="white" @click="selectType(item.type)">
                <span class="block-btn-label">{{ item.label }}</span>
              </v-btn>
            </v-col>
          </v-row>
          <!-- <v-divider class="my-6"></v-divider> -->
          <!-- Data-Driven ESG Blocks -->
          <v-row dense>
          <div class="dialog-title font-weight-bold block-btn-label mt-8 mb-6">{{ $t("esgPlatform.esgReport.databaseDrivenSections") }}</div>
            <v-col cols="12" v-for="item in staticBlocks" :key="item.type">
              <v-btn :class="['block-btn block-btn--static',selectedType === item.type ? 'block-btn--static-active' : '',]" block
                large depressed color="white" @click="selectType(item.type)">
                <span class="block-btn-label">{{ item.label }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <!-- Actions -->
      <v-card-actions class="justify-end px-6 pb-6">
        <v-btn outlined color="primary" class="mr-4" @click="close">{{ $t("esgPlatform.esgReport.cancel") }}</v-btn>
        <v-btn color="primary" class="white--text" @click="submit">{{ $t("esgPlatform.esgReport.submit") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    section: Object,
  },
  data() {
    return {
      visible: false,
      selectedType: 'heading',
      customizableBlocks: [
        { type: 'heading', label: this.$t('esgPlatform.esgReport.heading') },
        { type: 'paragraph', label: this.$t('esgPlatform.esgReport.paragraph') },
        { type: 'image', label: this.$t('esgPlatform.esgReport.image') },
        { type: 'stakeholders', label: this.$t('esgPlatform.esgReport.stakeholders') },
        { type: 'table', label: this.$t('esgPlatform.esgReport.table') },
      ],
      staticBlocks: [
        { type: 'esgProgressLineChart', label: this.$t('esgPlatform.esgReport.esgProgressLineChart') },
        { type: 'esgScorecard', label: this.$t('esgPlatform.esgReport.esgScorecard') },
      ],
    };
  },
  watch: {
    value(val) {
      this.visible = val;
    },
  },
  methods: {
    selectType(type) {
      this.selectedType = type;
    },
    close() {
      this.$emit('input', false);
    },
    submit() {
        // Return a new block template
      const templates = {
        heading: { type: 'heading', text: '' },
        paragraph: { type: 'paragraph', text: '' },
        image: { type: 'image', url: '', imageType: 'single' },
        imageGrid: { type: 'imageGrid', urls: [], cardSize: [5, 3] },
        stakeholders: { type: 'stakeholders', stakeholders: [] },
        table: { type: 'table', headers: [], rows: [] },
        esgProgressLineChart: { type: 'esgProgressLineChart', data: [] },
        esgScorecard: { type: 'esgScorecard', scores: [] },
      };
      this.$emit('save', {
        ...templates[this.selectedType],
        settings: { bgColor: '#ffffff', fontColor: '#101010', font: 'Poppins',},
      });
      this.close();
    },
  },
};
</script>

<style scoped>
.dialog-header {
  background: #167a3c;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.dialog-title {
  font-size: 20px;
}

.block-btn {
  border: 1.5px dashed #bdbdbd !important;
  border-radius: 12px !important;
  background: #fff !important;
  color: #333 !important;
  font-size: 18px !important;
  font-weight: 500 !important;
  height: 80px !important;
  transition: all 0.2s ease-in-out;
}

.block-btn--active {
  background: #06c47c !important;
  color: #fff !important;
  border: none !important;
  box-shadow: 0 2px 8px rgba(6, 196, 124, 0.3);
}

.block-btn--static {
  border: 1.5px dashed #000000 !important;
  background: #dff6e4 !important;
  color: #000000 !important;
}

.block-btn--static-active {
  background: #06c47c !important;
  color: #fff !important;
  border: none !important;
  box-shadow: 0 2px 4px rgb(69, 255, 146);
}

.block-btn-label {
  width: 100%;
  text-align: center;
}
</style>